<template>
  <div>

    <v-row no-gutters class="mt-10">
      <v-col>
        <v-data-table
            class="cp-list"
            :headers="headers"
            :items="items"
            :loading="loading"
            :server-items-length="total"
            :options.sync="options"
        >
          <template #item.createdAt="{item}">
            <span style="white-space: nowrap">
              {{ item.createdAt | formatDate }}
            </span>
          </template>

          <template #item.id="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

          <template #item.evse.chargingPointId="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

          <template #item.paymentMethodId="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

          <template #item.evse.chargingPointIdentifier="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

          <template #item.token.id="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

          <template #item.token.customerId="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

          <template #item.token.evcoId="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

          <template #item.sessionId="{value}">
            <span style="white-space: nowrap" v-if="value">
              {{ value }}
              <v-btn small icon @click="copyToClipboard(value)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
            <span v-else>-</span>
          </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn @click="download" small>
          <v-icon left>mdi-download</v-icon>
          {{ $t('export') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>


</template>

<script>


import SessionAuthorizationRepository from "@repository/SessionAuthorizationRepository";


export default {
  components: {

  },
  data() {
    return {
      loading: false,
      options: {
        sortBy: ['createdAt'],
        sortDesc: [true],
      },
      total: 0,
      items: [],
    }
  },
  props: {
    token: Object,
    customer: Object,
    chargingPoint: Object,
    organization: Object,
  },
  mounted() {
    if(!this.currentUser.permissions.includes('OPERATOR_READ')) {
      this.$router.replace({name: 'dashboard'})
    }
  },

  watch: {
    options: {
      handler() {
        this.loadData()
      },
      deep: true
    }
  },

  computed: {
    headers() {
      return [
        {text: this.$t('created-at'), value: 'createdAt'},
        {text: this.$t('authorization-id'), value: 'id'},
        {text: this.$t('authorization-method'), value: 'method'},
        {text: this.$t('charging-point-id'), value: 'evse.chargingPointId'},
        {text: this.$t('charging-point-identifier'), value: 'evse.chargingPointIdentifier'},
        {text: this.$t('evse-id'), value: 'evse.evseId'},
        {text: this.$t('network'), value: 'evse.network'},
        {text: this.$t('payment-method-id'), value: 'paymentMethodId'},
        {text: this.$t('session-authorization.reject-reason'), value: 'rejectReason'},
        {text: this.$t('session-id'), value: 'sessionId'},
        {text: this.$t('status'), value: 'status'},
        {text: this.$t('token.id'), value: 'token.id'},
        {text: this.$t('customer-id'), value: 'token.customerId'},
        {text: this.$t('evco-id'), value: 'token.evcoId'},
        {text: this.$t('token-uid'), value: 'token.uid'},
        {text: this.$t('transaction-id'), value: 'transactionId'},
        {text: this.$t('authorization-type'), value: 'type'},
      ]
    },
  },

  methods: {

    loadData() {

      this.loading = true
      let options = this.options
      let query = ""
      let tokenId = this.token?.id
      let customerId = this.customer?.id
      let chargingPointId = this.chargingPoint?.id
      let organizationId = this.organization?.id
      let offset = options.itemsPerPage * options.page - options.itemsPerPage;
      let limit = options.itemsPerPage;
      let sortBy = options.sortBy.length > 0 ? options.sortBy[0] : 'createdAt'
      let sortOrder = options.sortDesc.length > 0 && options.sortDesc[0] ? 'desc' : 'asc'
      SessionAuthorizationRepository.search({
        query,
        offset,
        limit,
        sortBy,
        sortOrder,
        tokenId,
        customerId,
        chargingPointId,
        organizationId,
      }).then(result => {
        this.total = result.total
        this.items = result.items
        this.loading = false
      }).catch(err => {
        this.notifyError(err)
        this.loading = false
      })
    },

    download() {
      this.showLoading(true)
      let tokenId = this.token?.id
      let chargingPointId = this.chargingPoint?.id
      let customerId = this.customer?.id
      let organizationId = this.organization?.id
      SessionAuthorizationRepository.exportCsv({
        tokenId,
        chargingPointId,
        customerId,
        organizationId,
      }).then(response => {
        this.showLoading(false)
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    }


  }
}
</script>